import * as React from 'react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

export class ApiUtility {
  static getQueryParams(params: { [key: string]: any }, allowEmpty = false): string {
    let queryParams = '';
    for (const key of Object.keys(params)) {
      let paramValue = params[key];
      if (paramValue === null || paramValue === undefined) {
        paramValue = '';
      }
      if ((!allowEmpty && paramValue) || allowEmpty) {
        queryParams = queryParams ? `${queryParams}&${key}=${paramValue}` : `?${key}=${paramValue}`;
      }
    }
    return queryParams;
  }

  static getFetchErrorMessage(error: FetchBaseQueryError): React.ReactElement | null {
    if (!error) {
      return null;
    }
    const { data } = error as FetchBaseQueryError;
    if (!data) {
      return null;
    }
    if (typeof data === 'string') {
      return <>{data}</>;
    } else if (typeof data === 'object') {
      const { status, title } = data as { status: number; title: string };
      return (
        <div className='font-weight-bold'>
          {status || ''} {title || ''}
        </div>
      );
    }
    return null;
  }
}
